import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteDeviationDisruptionReason(
  uuid: string
): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/deviation-disruption-activity/${uuid}`)
}
